export const SideMenuBarError = () => {
	return <p color='#ffffff'>Error Occured!</p>;
};
